import React from 'react';
import AdminLayout from "./admin";
import Login from './login'
const Layout = ({children}) => <AdminLayout> {children} </AdminLayout>;

export {Layout, Login};